/**
 * Formas de red de los comentarios públicos del blog, tal cual las emite la
 * API (snake_case). Contrato: `perronstore-api` `docs/api/blog-api.md`
 * § «Público · comentarios» (B88, B89, B93). Solo las lee
 * `blog-comments.mappers.ts`; el resto del front trabaja con la vista.
 */

/** Topes de B89 (`BlogComment::BODY_MAX`, `AUTHOR_NAME_MAX`, `AUTHOR_EMAIL_MAX`). */
export const BLOG_COMMENT_LIMITS = {
  body: 2000,
  name: 120,
  email: 255,
} as const;

/** Una respuesta del hilo: sin `replies` (un solo nivel, B40). */
export interface BlogCommentReplyApi {
  id: number;
  author_name: string;
  body: string;
  created_at: string;
  is_staff?: boolean;
  /** Solo aparece, a `true`, si el admin recortó el texto. */
  edited?: boolean;
}

/** Una raíz del hilo; `replies` solo existe en las raíces. */
export interface BlogCommentApi extends BlogCommentReplyApi {
  replies?: BlogCommentReplyApi[];
}

/** `meta` del `GET`: cuenta solo raíces. */
export interface BlogCommentsMetaApi {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

/** `GET /web/blog/posts/{slug}/comments`. */
export interface BlogCommentsListResponse {
  data: BlogCommentApi[];
  meta: BlogCommentsMetaApi;
}

/**
 * Cuerpo del `POST /web/blog/posts/{slug}/comments`.
 *
 * - `author_name`/`author_email` solo viajan sin sesión: con sesión la API los
 *   toma de la cuenta (B89) y el front no los pinta ni los manda.
 * - `website` es el honeypot (B93/B111): viaja siempre, tal cual.
 * - `parent_id` solo si es una respuesta.
 * - `subscribe_to_replies` no existe aquí a propósito (B114).
 */
export interface BlogCommentCreatePayload {
  body: string;
  author_name?: string;
  author_email?: string;
  website: string;
  parent_id?: number;
}

/** `201` del `POST`: el comentario nace pendiente y no entra al hilo. */
export interface BlogCommentCreateResponse {
  data: {
    id: number;
    author_name: string;
    body: string;
    created_at: string;
    parent_id?: number;
  };
  message?: string;
}
